var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metadata grid"},[(_vm.isLoading)?_c('loading-overlay'):_vm._e(),_vm._v(" "),(_vm.hasAllMetadata)?_c('metadata-box',{attrs:{"metadata":_vm.metadata,"userdata":_vm.userdata,"id":_vm.userId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }